// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ta-apps {
  width: 45px;
  height: 45px;
  position: inherit;
  display: inherit;
  background: white;
  padding-top: 3px;
  cursor: pointer;
}
.ta-app-parent {
  display: flex;
  padding-left: 8px;
  /* justify-content: center; */
  align-self: center;
  padding-bottom: 6px;
}
.ta-app-parent:hover > svg {
  fill: rgba(205, 205, 205, 1) !important;
}
.app-menu-open {
  background-color: rgba(0, 126, 167, 1);
}
.app-menu {
  padding-top: 2px;
  padding-right: 6px;
  padding-left: 6px;
  padding-bottom: 6px;
  margin-top: 2px;
}
.app-menu-svg:hover {
  fill: rgba(205, 205, 205, 1) !important;
}
.dd-list-container {
  box-shadow: 0px 19px 19px RGBA(0, 0, 0, 0.26);
  border: 1px solid rgba(181, 181, 181, 181);
  border-top: 10px #007ea7 solid;
  position: relative;
  left: 11px;
  top: -36px;
  max-height: 500px;
  overflow: auto;
  position: absolute;
  padding: 5px;
  background-color: white;
  min-width: 300px;
}

.dd-list {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: unset;
  width: 100%;
  margin-bottom: 0px;
}
.dd-list-title {
  display: flex;
  flex-direction: row;
  font-size: 16px;
  width: 100%;
  padding-top: 4px;
  padding-bottom: 4px;
}
.dd-list-title:hover {
  color: rgba(0, 126, 167, 1);
  text-decoration: underline;
  text-decoration-color: rgba(0, 126, 167, 1);
  background-color: #cfeaf8;
}
.dd-list-subtitle {
  font-size: 16px;
  margin-left: 20px;
}
.dd-list-item {
  cursor: pointer;
  font-size: 14px;
}
.dd-icon-list-item {
  width: 20px;
  margin-right: 6px;
  margin-top: -2px;
  margin-left: 6px;
}
.ta-center-box {
  display: -ms-flexbox;
  display: -moz-flex;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-list-collapse {
  margin-left: auto;
}

.hover-state:hover {
  color: rgba(0, 126, 167, 1);
  text-decoration: underline;
  text-decoration-color: rgba(0, 126, 167, 1);
  background-color: #cfeaf8;
}

.close-x {
  margin-top: 4px;
  cursor: pointer;
  margin-left: auto;
  margin-right: 4px;
}

.close-x:hover .close-icon {
  fill: black;
}
.close-icon {
  fill: rgba(165, 165, 165, 1);
}

.close-x-subtitle {
  cursor: pointer;
  margin-left: auto;
  margin-right: 4px;
  padding-left: 8px;
}

.close-x-subtitle:hover .close-icon {
  fill: black;
}
`, "",{"version":3,"sources":["webpack://./src/components/tabsApps/style/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,6CAA6C;EAC7C,0CAA0C;EAC1C,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".ta-apps {\n  width: 45px;\n  height: 45px;\n  position: inherit;\n  display: inherit;\n  background: white;\n  padding-top: 3px;\n  cursor: pointer;\n}\n.ta-app-parent {\n  display: flex;\n  padding-left: 8px;\n  /* justify-content: center; */\n  align-self: center;\n  padding-bottom: 6px;\n}\n.ta-app-parent:hover > svg {\n  fill: rgba(205, 205, 205, 1) !important;\n}\n.app-menu-open {\n  background-color: rgba(0, 126, 167, 1);\n}\n.app-menu {\n  padding-top: 2px;\n  padding-right: 6px;\n  padding-left: 6px;\n  padding-bottom: 6px;\n  margin-top: 2px;\n}\n.app-menu-svg:hover {\n  fill: rgba(205, 205, 205, 1) !important;\n}\n.dd-list-container {\n  box-shadow: 0px 19px 19px RGBA(0, 0, 0, 0.26);\n  border: 1px solid rgba(181, 181, 181, 181);\n  border-top: 10px #007ea7 solid;\n  position: relative;\n  left: 11px;\n  top: -36px;\n  max-height: 500px;\n  overflow: auto;\n  position: absolute;\n  padding: 5px;\n  background-color: white;\n  min-width: 300px;\n}\n\n.dd-list {\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  padding: unset;\n  width: 100%;\n  margin-bottom: 0px;\n}\n.dd-list-title {\n  display: flex;\n  flex-direction: row;\n  font-size: 16px;\n  width: 100%;\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n.dd-list-title:hover {\n  color: rgba(0, 126, 167, 1);\n  text-decoration: underline;\n  text-decoration-color: rgba(0, 126, 167, 1);\n  background-color: #cfeaf8;\n}\n.dd-list-subtitle {\n  font-size: 16px;\n  margin-left: 20px;\n}\n.dd-list-item {\n  cursor: pointer;\n  font-size: 14px;\n}\n.dd-icon-list-item {\n  width: 20px;\n  margin-right: 6px;\n  margin-top: -2px;\n  margin-left: 6px;\n}\n.ta-center-box {\n  display: -ms-flexbox;\n  display: -moz-flex;\n  display: -webkit-flex;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.menu-list-collapse {\n  margin-left: auto;\n}\n\n.hover-state:hover {\n  color: rgba(0, 126, 167, 1);\n  text-decoration: underline;\n  text-decoration-color: rgba(0, 126, 167, 1);\n  background-color: #cfeaf8;\n}\n\n.close-x {\n  margin-top: 4px;\n  cursor: pointer;\n  margin-left: auto;\n  margin-right: 4px;\n}\n\n.close-x:hover .close-icon {\n  fill: black;\n}\n.close-icon {\n  fill: rgba(165, 165, 165, 1);\n}\n\n.close-x-subtitle {\n  cursor: pointer;\n  margin-left: auto;\n  margin-right: 4px;\n  padding-left: 8px;\n}\n\n.close-x-subtitle:hover .close-icon {\n  fill: black;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
